import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Y from '../../../y18n'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import * as productActions from '../../../store/products'
import * as simcardActions from '../../../store/simcards'
import Styles from '../../../common/styles'
const mapStateToProps = state => ({
  simcards: state.simcards,
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  simcardActions: bindActionCreators(simcardActions, dispatch),
  productActions: bindActionCreators(productActions, dispatch)
})

class EditSimcardDialog extends Component {
  state = {
    status: null,
    smsStatus: null
  }

  closeFormDialog = () => {
    this.props.simcardActions.resetActive()
  }

  inputChanged = name => e => {
    this.props.simcardActions.updateActive(name, e.target.value)
    if (name === 'country') {
      this.props.productActions.getProductsForCountry(e.target.value)
    }
  }

  submitChanges = (e, simcard) => {
    e.preventDefault()
    this.props.simcardActions.editSimcard(simcard)
  }

  switchChanged = name => e => {
    e.preventDefault()
    this.setState({ [name]: e.target.checked })
    this.props.simcardActions.changeStatus(this.props.simcards.active.id, name, e.target.checked)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.simcards !== prevState.simcards) {
      return { active: nextProps.simcards.active }
    } else return null
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.simcards.active && prevProps.simcards.active !== this.props.simcards.active) {
      this.props.productActions.getProductsForCountry(this.props.simcards.active.country)
    }
  }

  render () {
    const { classes, simcards, simcardActions, products } = this.props
    if (!simcards.active || simcards.new) return null
    return (
      <div>
        <Dialog
          open={simcards.active !== null}
          onClose={() => simcardActions.resetActive()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e, simcards.active)}>
            <DialogTitle>{Y`Edit simcard`}</DialogTitle>
            <DialogContent>
              <div className={classes.flexRow}>
                <TextField
                  margin='normal'
                  label={Y`IMSI`}
                  type='text'
                  value={simcards.active.imsi || ''}
                  onChange={this.inputChanged('imsi')}
                  className={classes.flexItemLeft}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  disabled
                />
                <TextField
                  margin='normal'
                  label={Y`MSISDN`}
                  type='text'
                  value={simcards.active.msisdn || ''}
                  onChange={this.inputChanged('msisdn')}
                  className={classes.flexItemMiddle}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  disabled
                />
                <TextField
                  margin='normal'
                  label={Y`ICC`}
                  type='number'
                  value={simcards.active.icc || ''}
                  onChange={this.inputChanged('icc')}
                  className={classes.flexItemRight}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  disabled
                />
              </div>
              <CountriesDropdown handleChange={this.inputChanged('country')} value={simcards.active.country || ''} />
              <TextField
                margin='normal'
                select
                label={Y`Product`}
                type='number'
                value={simcards.active.productId || ''}
                onChange={this.inputChanged('productId')}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: classes.menu
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              >
                {products.productsForCountry.map(product => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </TextField>
            </DialogContent>
            <DialogContent>
              <div
                className={classes.flexRow}
                style={{ justifyContent: 'space-around', paddingLeft: '50px', paddingRight: '50px' }}
              >
                <div className={classes.flexItemLeft} style={{ textAlign: 'center' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked
                        }}
                        disableRipple
                        checked={this.state.status !== null ? this.state.status : simcards.active.status === 'Active'}
                        onChange={this.switchChanged('status')}
                        value='status'
                      />
                    }
                    label={Y`Data status`}
                  />
                </div>
                <div className={classes.flexItemRight} style={{ textAlign: 'center' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked
                        }}
                        disableRipple
                        checked={
                          this.state.smsStatus !== null ? this.state.smsStatus : simcards.active.smsStatus === 'Active'
                        }
                        onChange={this.switchChanged('smsStatus')}
                        value='smsStatus'
                      />
                    }
                    label={Y`SMS status`}
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => simcardActions.resetActive()}>{Y`Cancel`}</Button>
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

EditSimcardDialog = connect(mapStateToProps, mapDispatchToProps)(EditSimcardDialog)
export default withStyles(Styles)(EditSimcardDialog)



// WEBPACK FOOTER //
// ./src/pages/simcards/containers/edit-simcard-dialog.js